import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import UsersPage from './pages/UsersPage';
import PromotionPage from './pages/PromotionPage';
import ServerPage from './pages/ServerPage';
import DashboardPage from './pages/DashboardPage';
import UserDevicesPage from './pages/UserDevicesPage';
import PlanPage from './pages/PlanPage';
import PaymentsPage from './pages/PaymentsPage';
import VersionPage from './pages/VersionPage';
import PartnershipPage from './pages/PartnershipPage';
import AppsPage from './pages/AppsPage';
import NoticePage from './pages/NoticePage';
import BannerPage from './pages/BannerPage';
import FaqPage from './pages/FaqPage';
import FileTransferLogPage from './pages/FileTransferLogPage';
import RelayTrafficLogPage from './pages/RelayTrafficLogPage';

const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="devices" element={<UserDevicesPage />} />
        <Route path="plans" element={<PlanPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="promotions" element={<PromotionPage />} />
        <Route path="versions" element={<VersionPage />} />
        <Route path="servers" element={<ServerPage />} />
        <Route path="contact" element={<PartnershipPage />} />
        <Route path="apps" element={<AppsPage />} />
        <Route path="notices" element={<NoticePage />} />
        <Route path="faqs" element={<FaqPage />} />
        <Route path="faqs" element={<FaqPage />} />
        <Route path="file-logs" element={<FileTransferLogPage />} />
        <Route path="relay-logs" element={<RelayTrafficLogPage />} />
        <Route path="banner" element={<BannerPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
